import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { futureOpportunitiesGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';

const FutureOpportunitySingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get("id");
  const [futureData, setFutureData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      futureOpportunitiesGet({id})
        .then(response => {
          setFutureData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, [])

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            <div className="single-page-wrap">
              <h3>{futureData.title}</h3>
              <SinglePageItemText 
                title="Opportunity/Contract Start Date"
                value={futureData.contract_start_date}
              />
              <SinglePageItemText 
                title="NCMBC Rep"
                value={futureData.posted_by}
              />
              <SinglePageItemText 
                title="Source of Info"
                value={futureData.source_info}
              />
              <SinglePageItemText 
                title="Industry"
                value={futureData.industry}
              />
              <SinglePageItemText 
                title="NAICS Code"
                value={futureData.naics}
              />
               <SinglePageItemText 
                title="Location"
                value={futureData.location}
              />
              <SinglePageItemText 
                title="State"
                value={futureData.state}
              />
              <SinglePageItemText 
                title="Agency"
                value={futureData.agency}
              />
              <SinglePageItemText 
                title="Organization"
                value={futureData.organization}
              />
              <SinglePageItemText
                title="Sub-Organization"
                value={futureData.sub_organization}
              />
              <SinglePageItemText 
                title="Project No."
                value={futureData.project_no}
              />
              <SinglePageItemText 
                title="Projected Year"
                value={futureData.project_year}
              />
              <SinglePageItemText 
                title="Procurement Method"
                value={futureData.procurement_method}
              />
              <SinglePageItemText 
                title="Minimum Budget 150000.00"
                value={futureData.budget_min}
              />
              <SinglePageItemText 
                title="Maximum Budget 150000.00"
                value={futureData.budget_max}
              />
              <SinglePageItemText 
                title="Budget Notes"
                value={futureData.budget_notes}
              />
              <SinglePageItemText 
                title="Status"
                value={futureData.status}
              />
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default FutureOpportunitySingle;